import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#112240]/95 backdrop-blur-md py-4 shadow-lg shadow-black/20' : 'bg-transparent py-6'}`} data-id="element-54">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-55">
        {/* Logo */}
        <div className="text-2xl font-bold text-[#D4AF37] cursor-pointer font-['Playfair_Display'] tracking-wide" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-56">
          Zen 2026
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-57">
          <button onClick={() => scrollToSection('beneficios')} className="text-[#FFF8F0] hover:text-[#D4AF37] transition-colors font-['Inter'] text-sm tracking-wide" data-id="element-58">
            Beneficios
          </button>
          <button onClick={() => scrollToSection('contenido')} className="text-[#FFF8F0] hover:text-[#D4AF37] transition-colors font-['Inter'] text-sm tracking-wide" data-id="element-59">
            Contenido
          </button>
          <button onClick={() => scrollToSection('precio')} className="text-[#FFF8F0] hover:text-[#D4AF37] transition-colors font-['Inter'] text-sm tracking-wide" data-id="element-60">
            Precio
          </button>
          <button onClick={() => scrollToSection('precio')} className="bg-[#D4AF37] text-white px-6 py-2.5 rounded-lg font-semibold font-['Inter'] text-sm hover:bg-[#E8C84A] transition-all shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:shadow-[0_0_25px_rgba(212,175,55,0.5)]" data-id="element-61">
            Consíguelo Ahora
          </button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-[#FFF8F0]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-62">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-63" /> : <MenuIcon size={28} data-id="element-64" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-[#112240] border-t border-[#1D3461] shadow-xl flex flex-col items-center py-6 gap-6" data-id="element-65">
          <button onClick={() => scrollToSection('beneficios')} className="text-[#FFF8F0] text-lg font-['Inter']" data-id="element-66">
            Beneficios
          </button>
          <button onClick={() => scrollToSection('contenido')} className="text-[#FFF8F0] text-lg font-['Inter']" data-id="element-67">
            Contenido
          </button>
          <button onClick={() => scrollToSection('precio')} className="text-[#FFF8F0] text-lg font-['Inter']" data-id="element-68">
            Precio
          </button>
          <button onClick={() => scrollToSection('precio')} className="bg-[#D4AF37] text-white px-8 py-3 rounded-lg font-semibold font-['Inter'] shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-69">
            Consíguelo Ahora
          </button>
        </div>}
    </header>;
}